import axios from 'axios';
import { LoaderFunctionArgs } from 'react-router-dom';

import { settingsLoader } from '../App';

const WORKSHOP_ID = 'pasta-workshop';

export interface PrepareDishRequest {
  participantId: string;
  orderId: string;
  dishName: string;
  quantity: number;
}

export interface ReadyDish {
  workshopId: string;
  participantId: string;
  orderId: string;
  dishName: string;
  readyAt: string;
  status: string;
}

export interface PrepareDishResponse {
  accepted: boolean;
  remainingServings: number;
  message: string;
  dish?: ReadyDish;
}

export interface CompleteOrderResponse {
  status: string;
  dish: ReadyDish;
}

export interface InProgressOrder {
  workshopId: string;
  participantId: string;
  orderId: string;
  dishName: string;
  quantity: number;
  remainingServings: number;
  status: string;
}

async function endpoint(operation: string): Promise<string> {
  if (window.SETTINGS === undefined) {
    await settingsLoader({} as LoaderFunctionArgs);
  }
  return `${window.SETTINGS.apiEndpoint}/${operation}`;
}

export async function prepareDish(request: PrepareDishRequest): Promise<PrepareDishResponse> {
  return (await axios.post(await endpoint('PrepareDish'), { ...request, workshopId: WORKSHOP_ID }))
    .data as PrepareDishResponse;
}

export async function completeOrder(orderId: string): Promise<CompleteOrderResponse> {
  return (await axios.post(await endpoint('CompleteOrder'), { workshopId: WORKSHOP_ID, orderId }))
    .data as CompleteOrderResponse;
}

export async function listInProgressOrders(): Promise<InProgressOrder[]> {
  const response = await axios.post(await endpoint('ListInProgressOrders'), { workshopId: WORKSHOP_ID });
  return (response.data.orders ?? []) as InProgressOrder[];
}

export async function listReadyDishes(): Promise<ReadyDish[]> {
  const response = await axios.post(await endpoint('ListReadyDishes'), { workshopId: WORKSHOP_ID });
  return (response.data.dishes ?? []) as ReadyDish[];
}
